import EmbeddedImage from './Image';

export default EmbeddedImage;
